import { mockBuilder } from '../utils/builderHelper.es.js';
import { StreamFile } from './StreamFile.es.js';

/** @module Mocks */ /** typedoc */
/**
 * Create an Audio Stream File with mp3 and ogg Urls
 * @returns {StreamFile}
 */
function anAudioStreamFile() {
    return mockBuilder(new StreamFile()).withMp3Uri('audio_mp3_url').withOggUri('audioOggUrl');
}
/**
 * Create an Audio Stream File with mp4 Url
 * @returns {StreamFile}
 */
function aVideoStreamFile() {
    return mockBuilder(new StreamFile()).withMp4Uri('videoMp4Url');
}

export { aVideoStreamFile, anAudioStreamFile };
